export default `
  unitPrices(cityId: $cityId, filters: $filters)
`;
